import React, { useState } from 'react';
import useFetchDropdowns from '../hooks/useFetchDropdowns';

const ProductFilters = ({ onFilterChange, handleReset }) => {
	const [filters, setFilters] = useState({
		CategoryId: '',
		SubCategoryId: '',
		SizeId: '',
		StyleCodeId: '',
		BrandId: '',
		ColorId: '',
		IsDisplayPortal: '',
	});

	const handleChange = (e) => {
		const { name, value } = e.target;
		setFilters((prev) => ({
			...prev,
			[name]: value,
		}));
	};

	const handleSearch = (e) => {
		e.preventDefault();
		onFilterChange(filters);
	};

	const handleClear = () => {
		setFilters({
			CategoryId: '',
			SubCategoryId: '',
			SizeId: '',
			StyleCodeId: '',
			BrandId: '',
			ColorId: '',
			IsDisplayPortal: '',
		});
		handleReset();
	};

	const {
		categoryDropdown,
		subCategoryDropdown,
		sizeDropdown,
		colorDropdown,
		brandDropdown,
		styleCodeDropdown,
	} = useFetchDropdowns();

	return (
		<form
			onSubmit={handleSearch}
			className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mb-6'>
			{[
				{
					label: 'Category',
					id: 'CategoryId',
					options: categoryDropdown,
				},
				{
					label: 'SubCategory',
					id: 'SubCategoryId',
					options: subCategoryDropdown,
				},
				{
					label: 'Size',
					id: 'SizeId',
					options: sizeDropdown,
				},
				{
					label: 'Color',
					id: 'ColorId',
					options: colorDropdown,
				},
				{
					label: 'Brand',
					id: 'BrandId',
					options: brandDropdown,
				},
				{
					label: 'Style',
					id: 'StyleCodeId',
					options: styleCodeDropdown,
				},
			].map(({ label, id, options }) => (
				<div key={id} className='block text-gray-700 mb-1'>
					<label>Select {label}</label>
					<select
						id={id}
						name={id}
						value={filters[id]}
						onChange={handleChange}
						className='border border-gray-300 bg-white rounded-md p-2 w-full text-gray-500 focus:border-gray-400 focus:outline-none'>
						<option value=''>Select {label}</option>
						{options?.map((item) => (
							<option key={item?.Id} value={item?.Id}>
								{item?.MasterValue}
							</option>
						))}
					</select>
				</div>
			))}
			<div className='w-full flex justify-end items-end gap-5 col-span-1 sm:col-span-2 md:col-span-4'>
				<button type='submit' className='globalButton  p-2 rounded cursor-pointer'>
					Search
				</button>
				<button
					type='button'
					onClick={handleClear}
					className='bg-gray-400 text-white p-2 rounded cursor-pointer'>
					Reset
				</button>
			</div>
		</form>
	);
};

export default ProductFilters;
